<template>
  <div class="bg-gray-200 mr-0 overflow-y-auto w-full maincomponent-area">
    <ApisGrid />
  </div>
</template>

<script>
import ApisGrid from "./ApisGrid";

export default {
  name: "apislist",
  components: { ApisGrid }
};
</script>
